import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'login', component: () => import('@/views/login/login.vue'), meta: { title: '登录' } },
  { path: '/loading', name: 'loading', component: () => import('@/views/loadingPage/loadingPage.vue'), meta: { title: '加载中' } },
  { path: '/project-select', name: 'project-select', component: () => import('@/views/projectSelect/projectSelect.vue'), meta: { title: '选择项目' } },
  { path: '/403', name: '403', component: () => import('@/views/error/403.vue'), meta: { title: '无权限' } },
  { path: '/404', name: '404', component: () => import('@/views/error/404.vue'), meta: { title: '页面不存在' } },
  {
    path: '/',
    component: Layout,
    redirect: '/question-topic-class/list',
    children: [
      // 题库管理
      { path: 'question-topic-class/list', name: 'question-topic-class-list', component: () => import('@/views/questionTopicClass/questionTopicClass.vue'), meta: { title: '题目分类', icon: 'el-icon-collection-tag', parent: '题库管理' } },
      { path: 'question-topic-type/list', name: 'question-topic-type-list', component: () => import('@/views/questionTopicType/questionTopicType.vue'), meta: { title: '试题类型', icon: 'el-icon-files', parent: '题库管理' } },
      { path: 'question-topic/list', name: 'question-topic-list', component: () => import('@/views/questionTopic/questionTopic.vue'), meta: { title: '试题管理', icon: 'el-icon-edit-outline', parent: '题库管理' } },
      // 考试管理
      { path: 'question-paper/list', name: 'question-paper-list', component: () => import('@/views/questionPaper/questionPaper.vue'), meta: { title: '试卷管理', icon: 'el-icon-document', parent: '考试管理' } },
      { path: 'question-paper-record/list', name: 'question-paper-record-list', component: () => import('@/views/questionPaperRecord/questionPaperRecord.vue'), meta: { title: '答题结果', icon: 'el-icon-data-line', parent: '考试管理' } },
      // PK对战
      { path: 'pkq-paper/list', name: 'pkq-paper-list', component: () => import('@/views/pkqPaper/pkqPaper.vue'), meta: { title: 'PK试卷', icon: 'el-icon-aim', parent: 'PK对战' } },
      { path: 'pkq-rule/list', name: 'pkq-rule-list', component: () => import('@/views/pkqRule/pkqRule.vue'), meta: { title: 'PK规则', icon: 'el-icon-set-up', parent: 'PK对战' } },
      { path: 'pkq-user-statistics/list', name: 'pkq-user-statistics-list', component: () => import('@/views/pkqUserStatistics/pkqUserStatistics.vue'), meta: { title: '用户统计', icon: 'el-icon-data-analysis', parent: 'PK对战' } },
      { path: 'pkq-user-wrong/list', name: 'pkq-user-wrong-list', component: () => import('@/views/pkqUserWrong/pkqUserWrong.vue'), meta: { title: '错题记录', icon: 'el-icon-warning', parent: 'PK对战' } },
      // 系统管理
      { path: 'auth-user/list', name: 'auth-user-list', component: () => import('@/views/authUser/authUser.vue'), meta: { title: '用户管理', icon: 'el-icon-user', parent: '系统管理' } },
      { path: 'auth-project/list', name: 'auth-project-list', component: () => import('@/views/authProject/authProject.vue'), meta: { title: '项目管理', icon: 'el-icon-office-building', parent: '系统管理' } },
      { path: 'auth-department/list', name: 'auth-department-list', component: () => import('@/views/authDepartment/authDepartment.vue'), meta: { title: '部门管理', icon: 'el-icon-share', parent: '系统管理' } }
    ]
  },
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

export default router
